import {h, Fragment} from "preact"
import { AutocompleteElement, useCurrencyFormatting } from "@nosto/preact"
import { useEffect, useMemo, useState } from "preact/hooks";
import { fetchPrice, productImagePlaceholder } from "../helpers"

export default function DropdownProduct({ product }) {
    const { format } = useCurrencyFormatting();
    const handle = useMemo(() => product.url.split('/products/')[1], []);
    const [ prices , setPrices ] = useState({ price: product.price, listPrice: product.listPrice })

    useEffect(() => {
        const getPrices = async () => {
            const data = await fetchPrice(handle);
            const highestSkuPrice = data.price_varies ? data.price_max : false;
            const highestPricedSku = data.variants.find(variant => variant.price === highestSkuPrice);
            if((highestSkuPrice / 100) !== product.price && highestPricedSku) {
                setPrices({
                    price: highestPricedSku.price / 100,
                    listPrice: highestPricedSku.compare_at_price ? highestPricedSku.compare_at_price / 100 : 0
                })
            } else {
                setPrices({
                    price: product.price,
                    listPrice: product.listPrice
                })
            }
        }
        getPrices();
    }, [])

    return (
        <li 
            className="ns-autocomplete__product" 
            role="option" 
            aria-selected="false"
            data-handle={handle}
        >
            <AutocompleteElement 
                hit={product} 
                class="ns-autocomplete__product-wrapper w-full text-black text-left flex flex-col cursor-pointer"
            >
                <div>
                    <img 
                        className="ns-autocomplete__product-image block w-full" 
                        src={`${product.imageUrl}&amp;width=150`}
                        alt={product.name} 
                        width="50" 
                        height="62.675" 
                    />
                </div>
                <div className="mt-[10px] flex flex-col">
                    <p className=" text-sm text-black m-0">
                        {product.name}
                    </p>
                    <div className="ns-autocomplete__product-price-container">
                        {(prices.listPrice && prices.listPrice > prices.price) ? (
                            <>
                            <span className="visually-hidden visually-hidden--inline">Regular price</span>
                            <span>
                                <s className="ns-autocomplete__product-regular-price text-grey-2">
                                    {format(prices.listPrice)}
                                </s>
                            </span>
                            <span className="visually-hidden visually-hidden--inline">Sale price</span>
                            <span className="ns-autocomplete__product-final-price">
                                {format(prices.price)}
                            </span>
                            </>
                        ) : (
                            <>
                            <span className="visually-hidden visually-hidden--inline">Regular price</span>
                            <span className="ns-autocomplete__product-final-price">
                                {format(prices.price)}
                            </span>
                            </>
                        )}
                    </div>
                </div>
            </AutocompleteElement>
        </li>
    )
}